import { render, staticRenderFns } from "./LandingCard.vue?vue&type=template&id=13799af8&scoped=true"
import script from "./LandingCard.vue?vue&type=script&lang=js"
export * from "./LandingCard.vue?vue&type=script&lang=js"
import style0 from "./LandingCard.vue?vue&type=style&index=0&id=13799af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13799af8",
  null
  
)

export default component.exports